import React from "react"
import { Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

import { QuoteFlex, RightBox } from "./quote.styled"

const Quote = ({ data, mobileColumnDisplay, isFirst, isLast, className }) => {
  const { image, quote, name, position } = data

  return (
    <QuoteFlex
      flexWrap="wrap"
      flexDirection={mobileColumnDisplay ? ["column", null, "row"] : "row"}
      py={24}
      px={[8, null, 16, 24]}
      className={`${className} ${isFirst ? "first" : ""} ${
        isLast ? "last" : ""
      } md:!pt-0`}
    >
      <Box
        width={mobileColumnDisplay ? [1, null, 0.35, 1] : [0.3, null, 0.35, 1]}
        mb={[0, 0, 0, 32]}
        pb={[16, null, 0]}
        className="quote-image-box md:pt-6"
      >
        <img src={image} alt={name} className="rounded-[4px]" />
      </Box>

      <RightBox
        width={mobileColumnDisplay ? [1, null, 0.65, 1] : [0.7, null, 0.65, 1]}
        pl={mobileColumnDisplay ? [0, null, 32, 0] : [16, null, 32, 0]}
        minHeight={["auto", "auto", "auto", 275, 225]}
        className="quote-text-box"
      >
        <TextElementNova
          text={`“${quote}”`}
          element="h4"
          className="Body-30-Dia-Normal mb-[24px]"
        />
        <Box mt={[0, 0, "auto"]}>
          <TextElementNova
            text={name}
            element="h4"
            className="Body-20-Dia-Strong mb-[4px]"
          />
          <TextElementNova
            text={position}
            element="h4"
            className="Body-10-Dia-Normal sm:mb-0 text-nova-transparency-black-60"
          />
        </Box>
      </RightBox>
    </QuoteFlex>
  )
}

export default Quote
